var React = require('react');

function CheckMarkInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_1498_8369)","key":0},React.createElement("path",{"d":"M6.7807 15C6.18475 15 5.61299 14.7658 5.19176 14.3482L0.387598 9.59674C-0.129199 9.08498 -0.129199 8.25587 0.387598 7.74411C0.904805 7.23276 1.74275 7.23276 2.25996 7.74411L6.7807 12.2172L18.74 0.383512C19.2572 -0.127837 20.0952 -0.127837 20.6124 0.383512C21.1292 0.895268 21.1292 1.72439 20.6124 2.23614L8.36965 14.3482C7.94842 14.7658 7.37666 15 6.7807 15Z","fill":"#1AA260"})),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_1498_8369"},React.createElement("rect",{"width":"21","height":"15","fill":"white"})))]);
}

CheckMarkInline.defaultProps = {"width":"21","height":"15","viewBox":"0 0 21 15","fill":"none"};

module.exports = CheckMarkInline;

CheckMarkInline.default = CheckMarkInline;
